import axios from "axios";
import { API_VERSION, BOT_DOMAIN } from "../constants";
import { TRole } from "../interfaces/users";

export const USER_URL = "/api/user/";
export const USER_CREATE_URL = "/api/user/create";
export const GET_USERS_URL = "/api/users";
export const GET_STATUSES_URL = "/api/users/statuses";
export const GET_USER_ACTIVATE = "api/user_activate/send";
export const GET_USER_ROLES = "api/roles";

export function createUser(data) {
  return axios.post(USER_CREATE_URL, { ...data, version: API_VERSION });
}

export function editUser(id, data) {
  return axios.put(`${USER_URL}${id}/edit`, data);
}

export function editContactViewContact(data) {
  return axios.put(`${USER_URL}me`, data);
}

export function deleteUser(id) {
  return axios.delete(`${USER_URL}${id}`);
}

export function getUsers(
  page: number,
  perPage: number,
  tariffId?: number,
  funnelStateId?: number,
  userRolesId?: string,
  boughtTariff?: boolean,
  userActive?: boolean,
  managerId?: number,
  segment1?: string,
  segment2?: string,
  segment3?: string,
  csv?: boolean
) {
  const notAdmin = userRolesId !== "ROLE_ADMIN";

  let url = `${GET_USERS_URL}?page=${page}&per_page=${perPage}${tariffId && notAdmin ? `&tariff=${tariffId}` : ""}${
    funnelStateId && notAdmin ? `&funnel_state=${funnelStateId}` : ""
  }${userRolesId ? `&roles=${userRolesId}` : ""}${boughtTariff ? `&bought_tariff=${1}` : ""}${
    typeof userActive === "boolean" ? `&active=${userActive}` : ""
  }${managerId ? `&manager_id=${managerId}` : ""}${segment1 && segment1 !== "Все" ? `&segment1=${segment1}` : ""}${
    segment2 && segment2 !== "Все" ? `&segment2=${segment2}` : ""
  }${segment3 && segment3 !== "Все" ? `&segment3=${segment3}` : ""}${csv ? `&csv=${csv}` : ""}`;

  return axios.get(url);
}

export function getUsersByExcel(csv?: boolean) {
  return axios.get(GET_USERS_URL, {
    params: {
      csv,
    },
  });
}

export const getUserBids = (data: { userId: number; page: number; perPage: number }) => {
  return axios.get(`api/user/${data.userId}/bids?page=${data.page}&per_page=${data.perPage}`);
};

export const getUsersCrops = id => {
  return axios.get(`api/user/${id}/crops`);
};

export function getStatuses() {
  return axios.get(GET_STATUSES_URL);
}

export function getUserById(id) {
  return axios.get(`${USER_URL}${id}`);
}

export function getUserActivate(email) {
  return axios.get(`${GET_USER_ACTIVATE}?email=${email}`);
}

export function createUserBidFilter(id, data) {
  return axios.post(`${USER_URL}${id}/bid_filter`, data);
}

export function getUserRoles() {
  return axios.get(`${GET_USER_ROLES}`);
}

export function getUserBidFilters(params) {
  return axios.get(`${USER_URL}${params.id}/bid_filters` + (params.type ? `?type=${params.type}` : ""));
}

export function getUserFilters(email, phone) {
  return axios.get(`/api/users/search${email ? `?email=${email}` : ""}${phone ? `?phone=${phone}` : ""}`);
}

export const getSettingGPT = (
  type: "main_promt" | "promt" | "dialog_opening" | "avatar" | "model" | "model_2",
  locale?: string,
  user_role?: TRole
) =>
  axios.get("/api/gpt_settings", {
    params: {
      type,
      locale,
      user_role,
    },
    baseURL: BOT_DOMAIN,
  });

export const editSettingGPT = (data: FormData) => axios.post("/api/gpt_settings", data, { baseURL: BOT_DOMAIN });

export const getGPTModels = () => axios.get(`/api/gpt_models`, { baseURL: BOT_DOMAIN });

export const deleteGPTChat = (telegram_id?: string) => axios.delete("/api/gpt/chat", { params: { telegram_id }, baseURL: BOT_DOMAIN });

export const getChatsGPT = (params: {
  telegram_id?: string;
  role?: string;
  phone?: string;
  email?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
  username?: string;
}) => axios.get("/api/gpt/messages_stat", { params, baseURL: BOT_DOMAIN });

export const getMessagesGPT = (telegram_id?: number | string) => {
  return axios.get("/api/gpt/messages", { params: { telegram_id }, baseURL: BOT_DOMAIN });
};
